import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon, CheckIcon } from 'lucide-react';
import { mainNav } from '../../data/navigation';
import { Logo } from '../brand/Logo';
export function Footer() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'error' | 'success'>('idle');
  const submit = (e: React.FormEvent) => {
    e.preventDefault();
    setStatus(/^\S+@\S+\.\S+$/.test(email) ? 'success' : 'error');
  };
  return <footer className="bg-berry text-white" data-id="element-183" data-mp="3s25b894lpdgf">
      <div className="mx-auto max-w-7xl px-5 pb-8 pt-14 lg:px-8" data-id="element-184" data-mp="3s13vvsgjy4sw">
        <div className="flex flex-col gap-10 lg:flex-row lg:items-end lg:justify-between" data-id="element-185" data-mp="3n2srhx910mi2">
          <div data-id="element-186" data-mp="3j2ihm9i45bxx">
            <Logo size="lg" data-id="element-187" data-mp="3j30cp2t1hk49" />
            <p className="mt-4 text-sm uppercase tracking-[0.3em] text-white/60" data-id="element-188" data-mp="3j3tkm73qifnz">Beauty, made personal.</p>
          </div>

          <div className="w-full max-w-md" data-id="element-189" data-mp="393szqgq7vrho">
            <p className="text-sm font-medium" data-id="element-190" data-mp="394ufgyi6h25q">10% korting op je eerste bestelling</p>
            {status === 'success' ? <p className="mt-3 flex h-12 items-center gap-2 text-sm" role="status" data-id="element-191" data-mp="2kbtl4zw4eknu">
                <CheckIcon className="h-4 w-4 text-blush" data-id="element-192" data-mp="2p5e9e07ww09u" /> Check je inbox voor je code.
              </p> : <form onSubmit={submit} noValidate className="mt-3" data-id="element-193" data-mp="2babxmwgdvgp4">
                <label htmlFor="nl-email" className="sr-only" data-id="element-194" data-mp="2gcb0m587oblj">E-mailadres</label>
                <div className="flex h-12 items-center rounded-full border border-white/25 pl-5 pr-1 focus-within:border-white" data-id="element-195" data-mp="340u487gbg07a">
                  <input id="nl-email" type="email" value={email} onChange={e => {
                setEmail(e.target.value);
                if (status === 'error') setStatus('idle');
              }} placeholder="jouw@email.nl" aria-invalid={status === 'error'} className="min-w-0 flex-1 bg-transparent text-sm text-white placeholder:text-white/45 focus:outline-none" data-id="element-196" data-mp="381w9b4wwz6h6" />
                  <button type="submit" className="grid h-10 w-10 place-items-center rounded-full bg-white text-berry transition-colors duration-150 hover:bg-blush" aria-label="Aanmelden" data-id="element-197" data-mp="zje437nih0pv">
                    <ArrowRightIcon className="h-4 w-4" data-id="element-198" data-mp="ptcluwhuaciv" />
                  </button>
                </div>
                {status === 'error' && <p className="mt-2 text-xs text-blush" data-id="element-199" data-mp="kuhyricua1sy">Vul een geldig e-mailadres in.</p>}
              </form>}
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-5 border-t border-white/15 pt-6 text-sm lg:flex-row lg:items-center lg:justify-between" data-id="element-200" data-mp="fxhv1e3gpb50">
          <nav aria-label="Footer" data-id="element-201" data-mp="6v8lorjxjnt7">
            <ul className="flex flex-wrap gap-x-6 gap-y-2" data-id="element-202" data-mp="6w1mzd04dl3y">
              {[...mainNav, {
              to: '/over-amira',
              label: 'Over Amira'
            }].map(l => <li key={l.to} data-id="element-203" data-mp="218rg3sinyqaa">
                  <Link to={l.to} className="text-white/65 transition-colors duration-150 hover:text-white" data-id="element-204" data-mp="219t22s17wx6s">{l.label}</Link>
                </li>)}
            </ul>
          </nav>
          <p className="text-white/50" data-id="element-205" data-mp="2dq26m151ce86">© 2026 AMIRA Beauty · iDEAL · Klarna · PayPal</p>
        </div>
      </div>
    </footer>;
}